import React from 'react'
import { useTranslation } from "react-i18next"
import { Grid } from '@material-ui/core'
import { Container } from '@material-ui/core'
import mailFoot from '../../../assets/logos/icon_envio.png'
import { DialogSystemGLPure } from '../../pures'
import './email-confirmation.css'

const EmailConfirmation = (props) => {
  const { t } = useTranslation()

  return (
    <div className='email-confirmation-center-container-email-confirm'>
      <Container fixed className='container email-confirmation-user-register-container-email' style={{ width: '600px' }} spacing={4}>
        <Container style={{ display: 'flex', justifyContent: 'center' }}>
          <Grid container className='form' lg={12} md={12} style={{ display: 'flex', justifyContent: 'center', color: '#4E4E4E' }}>
            <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={{ display: 'flex', justifyContent: 'center' }}>
              <img alt='MailFoot' src={mailFoot} style={{ height: '75px', padding: '10px' }} />
            </Grid>
            <Grid container className='form' lg={12} md={12}>
              <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <p>{t('emailConfirmation.sendEmail')}</p>
              </Grid>
              <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <p className="email-confirmation-color-email email-confirmation-oblique">{props.userLogin || ''}</p>
              </Grid>
              <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='item-renovation message-renovation'>
                <p>{(props.canSendEmail) ? t('emailConfirmation.messageLogin') : t('emailConfirmation.message')}</p>
              </Grid>
              <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='item-renovation' style={{ textAlign: 'center' }}>
                <span className='email-confirmation-color-email email-confirmation-oblique'>{t('emailConfirmation.contactSales')}</span>
              </Grid>
              <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='item-renovation' style={{ marginBottom: '20px', textAlign: 'center' }}>
                <span className='email-confirmation-color-email email-confirmation-oblique'>{t('emailConfirmation.contactSupport')}</span>
              </Grid>
              <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                {(props.canSendEmail) ?
                  <div>
                    <button onClick={props.handleButtonLogOut} className='email-confirmation-button-send-verification'>{t('emailConfirmation.buttonSendVerificationMailExit')}</button>
                    <button className='email-confirmation-button-send-verification-exit' onClick={() => props.onSendVerificationEmail(props.canSendEmail)} style={{ marginLeft: '5px' }}>{t('emailConfirmation.buttonSendVerificationMailSend')}</button>
                  </div>
                  :
                  <button onClick={props.handleButtonLogOut} className='email-confirmation-button-send-verification-exit' style={{ marginLeft: '5px' }}>{t('emailConfirmation.buttonSendVerificationMailExit')}</button>
                }
              </Grid>
            </Grid>
          </Grid>
        </Container>


        {/* Notificaciones? */}
        <DialogSystemGLPure
          {...props}
          toggleLoadingRequesting={props.toggleLoadingRequesting}
          toggleCompletedRequesting={props.toggleCompletedRequesting}
          toggleErrorRequesting={props.toggleErrorRequesting}
        />

      </Container>
    </div >
  )
}

export { EmailConfirmation as default }
